import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";

export const UserMenuItemsContainerComponent: React.FC = observer(() => {
  const services = useServices();

  const menuItems = services.userMenu.userMenuItems;

  return (
      <>
        {menuItems.map(menuItem => <React.Fragment key={menuItem.key}>{menuItem.renderMenuItem()}</React.Fragment>)}
      </>
  );
});
